import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import {
  type MarketConsentOptions,
  type VerificationService,
  type ViewModel,
} from "../../../lib/types/types";
import { getMarketConsent } from "../../../lib/ProgramTheme/programThemeGetters";
import { OptInComponent } from "../OptIn/OptInComponent";

export interface MarketConsentWrapperProps {
  verificationService: VerificationService;
  isErrored: boolean;
  onChange: (value: any) => void;
  viewModel: ViewModel;
  disabled?: boolean;
}

const MarketConsentWrapperComponent = ({
  verificationService,
  isErrored,
  onChange,
  viewModel,
  disabled = false,
}: MarketConsentWrapperProps) => {
  const { programTheme } = verificationService;
  const marketConsentConfig: MarketConsentOptions = getMarketConsent(programTheme);

  const isFieldHidden = getFieldConfigByFieldId("marketConsentValue")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return marketConsentConfig.enabled ? (
    <OptInComponent
      isErrored={isErrored}
      isRequired={marketConsentConfig.required}
      verificationService={verificationService}
      value={(viewModel.metadata && viewModel.metadata.marketConsentValue) || false}
      onChange={(value) => onChange(value)}
      disabled={disabled}
    />
  ) : null;
};

// Do not use default export
export default MarketConsentWrapperComponent;

// Use this named export
export { MarketConsentWrapperComponent };
